import React from "react";
import { CheckCircle2, XCircle, Power, FlaskConical, Globe } from "lucide-react";

const MODES = [
  { key: "OFF", label: "Desligada", desc: "Padrão do deploy. Nenhuma cliente gera PIX agrupado.", icon: Power },
  { key: "PILOT", label: "Piloto", desc: "Somente clientes autorizadas, após validação financeira e de segurança.", icon: FlaskConical },
  { key: "ALL", label: "Todas as clientes", desc: "Somente após homologação completa e autorização administrativa.", icon: Globe },
];
const CHECKS = [
  ["signature_enforced", "Assinatura de webhook em EXIGIR (MONITORAR não conta)"],
  ["secrets_all_accounts", "Assinatura secreta em todas as contas recebedoras"],
  ["internal_financial_validated", "Validação financeira interna registrada"],
  ["provider_homologation_approved", "Homologação REAL aprovada pelo provedor (só para ALL)"],
];

export const ModeSelector = ({ mode, readiness, onPick }) => {
  const allowed = { OFF: true, PILOT: readiness.pilot_allowed, ALL: readiness.all_allowed };
  return (
    <section className="border border-[#EBE5DF] bg-white p-6" data-testid="pc-mode-section">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">Modo da Central</h2>
        <span className="text-xs uppercase tracking-widest px-3 py-1 bg-[#1A1A1A] text-white" data-testid="pc-current-mode">{mode}</span>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        {MODES.map(({ key, label, desc, icon: Icon }) => (
          <button key={key} disabled={key === mode || !allowed[key]} onClick={() => onPick(key)} data-testid={`pc-mode-${key}`}
            className={`text-left border p-4 transition-colors ${key === mode ? "border-[#1A1A1A] bg-[#FBF8F5]" : "border-[#EBE5DF] hover:border-[#1A1A1A]"} disabled:opacity-60 disabled:cursor-not-allowed`}>
            <Icon size={18} />
            <div className="font-semibold mt-2">{key} · {label}</div>
            <div className="text-xs text-[#5C5A57] mt-1">{desc}</div>
            {!allowed[key] && key !== mode && <div className="text-[11px] text-[#B42318] mt-2" data-testid={`pc-mode-${key}-blocked`}>Bloqueado: requisitos pendentes</div>}
          </button>
        ))}
      </div>
      <ul className="mt-5 space-y-2" data-testid="pc-readiness-list">
        {CHECKS.map(([k, label]) => (
          <li key={k} className="flex items-center gap-2 text-sm" data-testid={`pc-check-${k}`}>
            {readiness.checks[k] ? <CheckCircle2 size={16} className="text-[#067647]" /> : <XCircle size={16} className="text-[#B42318]" />}
            {label}
          </li>
        ))}
      </ul>
    </section>
  );
};
